<ng-container *ngIf="viewModel$ | async as vm">

  <app-dropdown [formControl]="scheduleControl" class="small" [class.selected]="vm.selected">
    <div class="schedule-value is-flex gap-8" dropdown-value>
      <app-icon class="text-24" name="schedule"></app-icon>
      <app-dropdown-value class="text-14 is-family-semiBold short"></app-dropdown-value>
    </div>

    <div class="is-flex is-column gap-8">

      @if (vm.heatingSchedules.length > 0) {
        <div class="schedule-type is-flex gap-12 text-grey-90">
          <app-icon class="text-24 text-grey-70" name="heating-mode"></app-icon>
          <app-text class="text-14 is-family-semiBold">{{ 'common-app.__HEATING_TITLE' | AsyncLang | async }}</app-text>
        </div>

        <div class="border"></div>

        <ng-container *ngFor="let schedule of vm.heatingSchedules">
          <app-dropdown-item [value]="schedule.id" [label]="schedule.name"></app-dropdown-item>
        </ng-container>
      }

      @if (vm.coolingSchedules.length > 0) {
        <div class="schedule-type is-flex gap-12 text-grey-90">
          <app-icon class="text-24 text-grey-70" name="cooling-mode"></app-icon>
          <app-text class="text-14 is-family-semiBold">{{ 'common-settings.__DATA_COOLING' | AsyncLang | async }}</app-text>
        </div>

        <div class="border"></div>

        <ng-container *ngFor="let schedule of vm.coolingSchedules">
          <app-dropdown-item [value]="schedule.id" [label]="schedule.name"></app-dropdown-item>
        </ng-container>
      }

      @if (vm.autoSchedules.length > 0) {
        <div class="schedule-type is-flex gap-12 text-grey-90">
          <app-icon class="text-24" name="auto-mode"></app-icon>
          <app-text class="text-14 is-family-semiBold">{{ 'legrand-app.__LEG_DASHBOARD_AUTO' | AsyncLang | async }}</app-text>
        </div>

        <div class="border"></div>

        <ng-container *ngFor="let schedule of vm.autoSchedules">
          <app-dropdown-item [value]="schedule.id" [label]="schedule.name"></app-dropdown-item>
        </ng-container>
      }

    </div>
  </app-dropdown>

</ng-container>
